import { useTechnicalCategoryBookmarks } from '@hooks';
import { useStore } from '@stores';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import Presentation from './TechnicalCategoryBookmarkMenu.presentation';

interface IProps {
  orderId: string;
}

export const TechnicalCategoryBookmarkMenu: React.FC<IProps> = observer(({ orderId }) => {
  const { technicalCategoryStore } = useStore();

  const { bookmarks } = useTechnicalCategoryBookmarks({ orderId });

  const onBookmarkClick = useCallback(
    async (id: string) => {
      await technicalCategoryStore.getSubCategoriesByCategoryId({ id }).then(() => {
        const selectedBookmark = bookmarks.find((x) => x.technicalCategoryId === id);
        technicalCategoryStore.setSelectedBookmark(selectedBookmark!);
      });
    },
    [technicalCategoryStore, bookmarks]
  );

  const onRemoveBookmarkClick = useCallback(
    async (id: string) => {
      await technicalCategoryStore.removeBookmark({ id }).then(() => {
        technicalCategoryStore.clearSubCategories();
      });
    },
    [technicalCategoryStore]
  );

  return (
    <Presentation
      bookmarks={bookmarks}
      onBookmarkClick={onBookmarkClick}
      onRemoveBookmarkClick={onRemoveBookmarkClick}
    />
  );
});
